'use strict';
import KNB from '@dp/knb';
import UA from '@dp/util-m-ua';
import Login from '@dp/util-login';
import reqwest from 'reqwest';
import WhereAmI from '@dp/whereami';
import Cookie from '@dp/cookie';
// import 'url-search-params-polyfill';
// import 'whatwg-fetch';

module.exports = {
    cache: {},
    shareRedirect (justCheck) {
        if (this.cache.urlSource === undefined) {
            this.cache.urlSource = this.parseQuery('source') || ''
        }
        if (!this.isApp() && this.cache.urlSource === 'mShare') {
            if (!justCheck) {
                location.href = 'https://evt.dianping.com/synthesislink/15763.html?url=' + encodeURIComponent(location.href)
            }
            return false;
        }
        return true;
    },
    extend(to, from) {
        to = to || {}
        for (var key in from) {
            from.hasOwnProperty(key) && (to[key] = from[key])
        }
        return to
    },
    isObjectEmpty (obj) {
        for (var key in obj) {
            if(obj.hasOwnProperty(key)){
                return false;
            }
        }
        return true;
    },
    getTypeList () {
        return {
            0: '全部',
            1: '美食',
            6: '玩乐',
            2: '丽人',
            3: '结婚',
            4: '亲子',
            5: '家装',
            8: '培训',
            9: '酒旅',
            10: '生活',
            99: '其它'
        }
    },
    getFilterList () {
        return {
            0: '无',
            1: '只看未抢',
            2: '可用pass卡',
            3: 'vclub',
            99: '到综'
        }
    },
    getUA() {
        if (!this.cache.ua) {
            this.cache.ua = UA();
        }
        return this.cache.ua;
    },
    isIOS() {
        // TODO: Version
        return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
    isIPhoneX() {
        var ua = this.getUA()
        if (ua.model === 'iPhoneX') return true
        let _winHeight = window.screen && window.screen.height || window.outerHeight || window.innerHeight
        let _winWidth = window.screen && window.screen.width || window.outerWidth || window.innerWidth
        // 请先判断之上的isIOS()
        return _winHeight === 812 && _winWidth === 375
    },
    isVersion10(){
        let ua = this.getUA()
        return parseInt(ua.version) > 9;
    },
    isApp(app) {
        var ua = this.getUA()
        if (app) {
            return ua.type == app;
        }
        return /^(dpapp|mtgroup)$/i.test(ua.type);
    },
    getCx: function () {
        return new Promise((resolve, reject) => {
            if (this.isApp()) {
                if (this.cache.cx) {
                    resolve(this.cache.cx);
                } else {
                    KNB.getFingerprint({
                        success: (ret) => {
                            let cx = ret.fingerprint;
                            if (cx) {
                                this.cache.cx = cx;
                                resolve(cx);
                            } else {
                                resolve('');
                            }
                        },
                        fail: (msg) => {
                            resolve('');
                        }
                    });
                }
            } else {
                resolve('');
            }
        });
    },
    getToken: function() {
        return new Promise((resolve, reject) => {
            if (this.isApp()) {
                if (this.cache.token) {
                    resolve(this.cache.token);
                } else {
                    // let self = this;
                    KNB.getUserInfo({
                        success: (user) => {
                            let token = user.token;
                            if (token) {
                                this.cache.token = token;
                                resolve(token);
                            } else {
                                reject('unlogin');
                            }
                        },
                        fail: (msg) => {
                            reject('unlogin');
                        }
                    });
                }
            } else {
                resolve();
                // if (this.cache.token) {
                //     resolve()
                // } else {
                //     Login.check((r) => {
                //         if (r.isLogin) {
                //             this.cache.token = r.userInfo.token;
                //             resolve();
                //         } else {
                //             reject('unlogin');
                //         }
                //     })
                // }
            }
        });
    },
    getDomain(isStatic) {
        let url = location.href,
            prefix = isStatic ? 'h5' : 'm',
            domain;
        if (~url.indexOf('.dianping.com')) {
            if (~url.indexOf('ppe.dianping.com')) {
                domain = '//ppe.' + prefix + '.dianping.com';
            } else {
                domain = '//' + prefix + '.dianping.com';
            }
        } else if (~url.indexOf('.51ping.com') || ~url.indexOf('.dev.sankuai.com')) {
            domain = '//' + prefix + '.51ping.com';
        } else {
            domain = '//' + prefix + '.dianping.com';
        }
        return location.protocol + domain;
    },
    reqwest(url, data = {}, method = 'GET', withCredentials = true) {
        return this.getToken().then((token) => {
            token && (data.token = token);
            let source = this.parseQuery('source');
            source && (data.source = source);
        }, () => {}).then(() => {
            return this._reqwest(url, data, method, withCredentials);
        });
    },
    _reqwest(url, data = {}, method = 'GET', withCredentials = true) {
        return reqwest({
                url: this.getDomain() + url,
                method: method,
                data: data,
                crossOrigin: true,
                type: 'json',
                withCredentials: withCredentials
            })
            .then((r) => {
                if (!!r) {
                    return Promise.resolve(r);
                } else {
                    return Promise.reject(`Illegal Result`);
                }
            })
            .fail((e) => {
                return Promise.reject(`Network response was not ok, resason: ${JSON.stringify(e)}`);
            })
    },
    _reqwest_fetch(url, data = {}, method = 'GET', withCredentials = true) {
        // deprecate: polyfill problem
        // TODO: Header
        let options = {
                method: method,
                mode: 'cors',
            },
            bodyObj

        withCredentials && (options.credentials = 'include');

        if (method == 'POST' && Object.prototype.toString.call(data) !== '[object FormData]') {
            // 说明1：后端不支持FormData格式数据
            // bodyObj = new FormData();
            // for (let key in data) {
            //     data.hasOwnProperty(key) && bodyObj.append(key, data[key]);
            // }
            // 说明2：OPTION对后端改动大
            // options.headers = {
            //     'Content-Type': 'application/json'
            // }
            // bodyObj = [];
            // for (let key in data) {
            //     data.hasOwnProperty(key) && data[key] && bodyObj.push(`${key}=${data[key]}`);
            // }
            // bodyObj = new URLSearchParams(bodyObj.join('&')) // TODO: polyfill
            bodyObj = new URLSearchParams(data);
        } else if (method == 'GET') {
            bodyObj = [];
            for (let key in data) {
                data.hasOwnProperty(key) && data[key] && bodyObj.push(`${key}=${data[key]}`);
            }
            if (bodyObj.length) {
                url += (~url.indexOf('?') ? '&' : '?') + bodyObj.join('&');
            }
        }
        method == 'POST' && (options.body = bodyObj || data);

        return fetch(this.getDomain() + url, options).then((response) => {
            if (response.ok) {
                return response.json().then((r) => {
                    if (!!r) {
                        return Promise.resolve(r)
                    } else {
                        return Promise.reject(`Illegal Result`)
                    }
                });
            } else {
                return Promise.reject(`Network response was not ok, status: ${response.status}`);
            }
        });
    },
    handleRedir(url, callback) {
        if (!this.shareRedirect()) return
        // `token=!`是点评的书写规范
        if (/token[=|%3D]!/.test(url)) {
            this.getToken().then(() => {
                if (typeof callback == 'function') {
                    callback(url)
                } else {
                    location.href = url
                }
            }, () => {
                Login(() => {
                    this.handleRedir(url, callback)
                }, () => {
                    console.log('login fail')
                })
            }).catch(() => {})
        } else {
            if (typeof callback == 'function') {
                callback(url)
            } else {
                location.href = url
            }
        }
    },
    parseQuery: function(attr) {
        if (!attr) return;
        let match = RegExp(`[?&]${attr}=([^&]*)`).exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' ')) // url中+号表示空格,要替换掉
    },
    getCity: function() {
        return new Promise((resolve, reject) => {
            let result;
            /**
             * 1. url search
             * 2. meituan APP 前端不解析
             * 3. 页面内城市/点评APP默认种cookie cityid
             * 4. 前端定位经纬度 -> city
             */
            if (result = this.parseQuery('cityid')) {
                resolve(result);
            } else if (this.isApp('mtgroup')) {
                reject({
                    message: 'business not support meituan cityid'
                });
            } else if (result = Cookie('cityid')) {
                resolve(result);
            } else {
                WhereAmI.config({
                    timeout: 3000,
                    enables: ['x5'],
                    wxAutoConfig: true,
                    city: true,
                    cityType: 'dianping',
                    source: 'fMeal',
                    sampling: 0.5
                });
                WhereAmI((res) => {
                    resolve(res.city.cityid);
                }, (err) => {
                    reject(err);
                });
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/common/js/util.js